export default __webpack_public_path__ + "695822e.png";